import { jsx as _jsx } from "react/jsx-runtime";
import { MOBILE_PADDING, TABLET_PADDING } from "@faire/retailer-visitor-shared/views/about/components/common";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { optimizeImageUrl } from "@faire/web--source/common/transform-images";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { useResponsiveValue } from "@faire/web--source/ui/hooks/useResponsiveValue";
import React from "react";
import styled from "styled-components";
export var ImageContent = function(param) {
    var description = param.description;
    var source = useResponsiveValue({
        mobileAndAbove: SOURCES.mobile,
        tabletAndAbove: SOURCES.tablet,
        desktopAndAbove: SOURCES.desktop
    });
    var width = useResponsiveValue({
        mobileAndAbove: 375,
        tabletAndAbove: 768,
        desktopAndAbove: 528
    });
    var height = useResponsiveValue({
        mobileAndAbove: 429,
        desktopAndAbove: 643
    });
    var isSSR = useIsSSR();
    // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
    var url = source[description];
    var optimizedUrl = optimizeImageUrl({
        url: url
    }, isSSR, {
        width: width,
        height: height,
        resizeMethod: "fit"
    });
    return /*#__PURE__*/ _jsx(ImageContainer, {
        children: /*#__PURE__*/ _jsx(Image, {
            src: optimizedUrl,
            alt: description
        })
    });
};
var SOURCES = {
    mobile: {
        "Store Entrance": "https://cdn.faire.com/fastly/8d40de240488080be48e49642179db9f54a08397818a3c13bdd81cd3769a5886.png",
        "Person Candle": "https://cdn.faire.com/fastly/78deb70001acb12caede782d472f2d670b2a235e0ff3105cd6a572a5aa915402.png"
    },
    tablet: {
        "Store Entrance": "https://cdn.faire.com/fastly/c813aee13838aa31c7df317fc7d72e6a26d58a582d15cfa9500a2cd47133918d.png",
        "Person Candle": "https://cdn.faire.com/fastly/2c64736327a4e811d02bac54573b8092fad4075a487b1e0abb499e4b78e5b5eb.png"
    },
    desktop: {
        "Store Entrance": "https://cdn.faire.com/fastly/87342d275c01dadd6ccf6b4d80de1ca23a745e4ed5af8d20200ffa1cc8a63ab9.png",
        "Person Candle": "https://cdn.faire.com/fastly/78deb70001acb12caede782d472f2d670b2a235e0ff3105cd6a572a5aa915402.png"
    }
};
var Image = styled.img.withConfig({
    componentId: "sc-b11ed6e9-0"
})([
    "display:block;width:100%;"
]);
var ImageContainer = styled.div.withConfig({
    componentId: "sc-b11ed6e9-1"
})([
    "margin:0 -",
    ";",
    "{margin:0 -",
    ";}",
    "{margin:0;width:528px;flex-shrink:0;}"
], MOBILE_PADDING, responsiveMediaQueries.tablet, TABLET_PADDING, responsiveMediaQueries.desktopAndAbove);
